
import { ClientDeployment } from "../app/shared/enums/client-deployment.enum";

export enum ENV_BUILD {
  EXCEEDERS = 0,
  STEMEXE,
  EBUILD,
  WELLNEXE
}

export const environment = {
  deploymentClient: ClientDeployment.DEFAULT, //Use this property for client customization
  build: ENV_BUILD.EXCEEDERS,
  production: false,
  isProduction: false,
  defaultDomainPostfix: ".stag.stemexe.com",
  engProClientCode: "engagementpro-ssdev",
  oppProClientCode: "OpportunityDev",
  oppProClientId: "XOP1972122200",
  oppProApiHost: "Https://oppprodevapi.azurewebsites.net",
  oppProApi: "Https://oppprodevapi.azurewebsites.net",
  idenediProviderUrl: "https://authapi.idenedi.com",
  idenediMlbackend: "https://idenedimlbackend-stag.azurewebsites.net",
  authClientId: "idenedi_web_client",
  authClientSecret: "7x63u81880lnfyk",
  ipDataServiceUrl: "https://api.ipdata.co",
  ipDataApiKey: "8785f9d599c704e529640ae22c70becae44748ddcdcb358725bc2391",
  apiHost: "https://api.idenedi.com",
  idenediStaticHost: "https://idenedistag.blob.core.windows.net",
  searchHost: "https://idenedisearch-prod-stag.azurewebsites.net",
  idenediWebHost: "https://idenedi-prod-stag.azurewebsites.net",
  technadoptApiHost: "https://technadoptqaui.azurewebsites.net",
  espApiHost: "https://qaesp.azurewebsites.net",
  webHost: "https://exceeders-app-staging.web.app",
  idenediGroupId: "GPI2018101700",
  idenediGroupIdForActivities: "GZH1964082700",
  supportUserId: "IPK1980101000",
  countDown: '',
  enableGroupsSelection: false,
  productContactFormWidgetUrl:
    "https://leadlineprodev.azurewebsites.net/static/component/v1.8.0.js",
  homePageTopicId: "e485bce5-2624-40d0-b0dc-b348a8a88179",
  homePageRequestId: "827",
  singleGroupApp: false,
  enableTopicHomePage: false,
  enableThemes: false,
  exceederClientId: "XTD1963050800",
  //engagementClientId: "XEP1968041200",
  engagementClientId: "XEP1982082900",
  staging: true,
  msalAuth: {
    clientId: "3b744188-ce41-4514-9117-2e028edac581",
    authority: "https://login.microsoftonline.com/common", //'bef7c58b-5197-4479-903d-9fb2e68261a7',
    validateAuthority: false,
    localId: "QHTm4Bg42._s18G-MztElxX0d~Y~JzY-tO",
    scopes: [
      "openid",
      "User.Read",
      "Calendars.ReadWrite",
      "Calendars.Read",
      "Calendars.ReadWrite.Shared",
      "Calendars.Read.Shared"
    ],
    endPoint: "https://graph.microsoft.com/v1.0"
  },
  SOCIAL_SHARING: {
    FB: {
      APP_ID: "345784772969902"
    },
    LINKEDIN: {
      APP_ID: "816bxkf51ta9m7",
      REDIRECT_URL:
        "https://idenedi-prod-stag.azurewebsites.net/web/socialShare/linkedin_callback.html",
      SHARE_POST_URL:
        "https://idenedi-prod-stag.azurewebsites.net/linkedin_share.php"
    },
    TWITTER: {
      APP_ID: "",
      LOADING_URL:
        "https://idenedi-prod-stag.azurewebsites.net/web/socialShare/loading.html",
      SHARE_POST_URL:
        "https://idenedi-prod-stag.azurewebsites.net/twitter_share.php"
    }
  },

  firebase: {
    apiKey: "AIzaSyAmrIImSs4nEBk9Ovcj6Kj_nLY_gaYo98M",
    authDomain: "exceeders-app-staging.firebaseapp.com",
    databaseURL: "https://exceeders-app-staging.firebaseio.com",
    projectId: "exceeders-app-staging",
    storageBucket: "exceeders-app-staging.appspot.com",
    messagingSenderId: "511503782615",
    appId: "1:511503782615:web:365af90f454ee485fa5692",
    measurementId: "G-J977B3P3SS",
    dynamicLink: {
      domainUriPrefix: "https://exceedersstaging.page.link",
      androidPackageName: "com.exceedgulf.exceeders.staging",
      iosBundleId: "com.exceedgulf.Exceeders.Staging"
    }
  },
  recaptcha3SiteKey: '',
  enableAppCheck: false,
  version: "4.1.4",
  higherBaseURL: 'https://qa-higher.azurewebsites.net',
  vacancyTempWork: true,
  customDomainFallbackUrl: 'https://exceeders-app-staging.web.app',
  engagementPro: {
    baseURL: 'https://engage.exceeders.com/webapi',
    clientId: 'XEP1992010100',
  },

  plannexe: {
    baseURL: 'https://engpro2devapi.azurewebsites.net',
    webLink: 'https://engpro2dev.azurewebsites.net',
    inviteURL: 'https://engpro2dev.azurewebsites.net/auth/user/invite/',
    simpleStartBaseURL: 'https://ss-staging-gateway.azurewebsites.net/webapi/api/TeamApi/',
    simpleStrataUrl:"https://ss-staging-gateway.azurewebsites.net/WebApi",
    file: {
      api: 'https://exceedfileserver.azurewebsites.net',
      clientID: 'EngagementProV2',
      apiKey: '5UU9-OO9Z-FSHC-YFOY'
    },
    idenedi: {
      api: 'https://api.idenedi.com',
      auth: 'https://idenedi-prod-stag.azurewebsites.net',
      clientID: 'XEP1982082900',
      redirect: 'https://engpro2dev.azurewebsites.net/auth/login/idenedi',
      group: 'https://idenedi-prod-stag.azurewebsites.net/linkgroup.html',
    },
    moduleLink: "/pages/engagement",
    isStemexe: true,
    chatAiBaseUrl: 'https://chataiex.azurewebsites.net',
    consoleEnabled: false,
  },
  sellexe: {
    baseUrl: 'https://oppprodevapi.azurewebsites.net/api',
    moduleLink: 'pages/sellexe/',
    webUrl: '',
    idenedi: {
      api: 'https://api.idenedi.com',
      auth: 'https://idenedi-prod-stag.azurewebsites.net',
      clientID: 'XSE1971081200',
      redirect: 'https://sellexedev.azurewebsites.net/auth/idenedicode/',
      group: 'https://idenedi-prod-stag.azurewebsites.net/linkgroup.html',
    }
  },
  simpleStrata:{
    mainURL: 'https://ss-staging-gateway.azurewebsites.net/webapi/',
    isStemexe: true,
  },
  notificationService: {
    apiConnectURL: 'https://notificationservice-auth-testing.azurewebsites.net',
    apiURL: 'https://notificationservice-api-testing.azurewebsites.net',
    clientID: 'GtU6Uc01y676',
    clientSecret: 'yhSL29kCUNPeY4gfVxSBmsym',
    grantType: 'client_credentials'
  },
  enableGlobalSlides: false,
  allowPublicAcess:true,
  intajyClientId:'XIN1973102300',
  intajyBaseUrl:'https://stemexe.meetexe.com',
  intajyApiUrl:'https://api.meetexe.com',
  intajyAppUrl:"https://api2.meetexe.com",
  aimeetexeApiUrl:'https://ai-api.meetexe.com',
  aimeetexeApiKey:'ST-ABNWmYopDy-vjVXRJxBA2dTrk-ZL3VJzNUSLcWss-cF6B7pkHgTS4g7C',
  virtualRoomIntajyApiUrl:"https://room-api.meetexe.com",
  virtualRoomClientId: 'XVR1957112300',
  connectexeDetailsUrl: 'https://www.perfexe.com/pages/connectexe-lb',
  forceProfileCompletion:false,
  defaultLocale: 'en',
  themeColors: {}
};
